import { ReactElement } from 'react';
import NotesIcon from '@material-ui/icons/Notes';

import './note-attachment-icon.styles.scss';
import { Box } from '@material-ui/core';

export interface INoteAttachmentIconProps {
	fontSize?: 'small' | 'inherit' | 'large' | 'default';
	className?: string;
	color?: string;
	noPadding?: boolean | undefined;
	noBackground?: boolean | undefined;
}
export function NoteAttachmentIcon(
	props: INoteAttachmentIconProps
): ReactElement {
	const { fontSize, className, color, noPadding, noBackground } = props;

	return (
		<Box
			className={`
                note-attachment-icon-container 
                ${noBackground ? '' : 'add-background'} 
                ${noPadding ? 'no-padding' : ''} 
                ${className ? className : ''}
            `}
		>
			<NotesIcon
				style={{ backgroundColor: color }}
				className={`note-attachment-icon`}
				fontSize={fontSize}
			/>
		</Box>
	);
}
